import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
	},
	filter: {
		LastDateTyp1: null as string | null,
		LastDateTyp2: null as string | null,
		LastDateTyp3: null as string | null,
		LastDateTyp4: null as string | null,
		LastDateTyp5: null as string | null,
		LastDateTyp6: null as string | null,
		DoKdy: null as string | null,
		TypId: null as number | null,
		ProvozovnaId: null as number | null,
		PracovnikId: null as number | null,
		MakeServis: null as boolean | null,
		MakeOV: null as boolean | null,
		MakeNV: null as boolean | null,
	},
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {
		async deleteItem({ state }, id: string | number) {
			const resp = await apiProvider.deleteEntity(id);

			if (resp.status === 200) {
				const index = state.table.rows.findIndex((row) => row.cells[state.table!.cellNames!.idColumn] === id);

				state.table.rows.splice(index, 1);
			}
		},
	},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
